import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import App from './App';
import storeInstance from "src/store/instance"
import { createStore } from 'src/store/instance'
import { Provider } from 'mobx-react'
import * as serviceWorker from './serviceWorker';

const store = createStore()

if (module.hot) {
  // @ts-ignore
  window.__store = store
}

ReactDOM.render(
  <React.StrictMode>
    <Provider store={storeInstance.get()}>
      <App  />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
